//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import ResponsiveImage from '@/components/modules/ResponsiveImage'
    import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
	import { required, min, email } from 'vee-validate/dist/rules';
	
	// Override the default message.
	extend('required', {
	...required,
	message: 'This field is required'
	});
	extend('min',{...min});
	extend('email',{...email});

    export default {
		components: {
			 ValidationObserver, ValidationProvider
		},
		data() {
			return {
				name: '',
				namelast: '',
				email: '',
				phone: '',
				comments: '',
                errors: [],
				formloading: false,
				formsuccess: false,
				formerror: false,
				inputFocus: false
			}
		},
		computed: {
			isComplete() {
				return this.name && this.email
			}
		},
		mutations: {
			updateMessage(state, message) {
				state.obj.message = message
			}
		},
		methods: {
			checkExit() {
				return this.formsuccess || this.formerror
			},
			changeFormvisibility() {
				this.formsuccess = false
				this.formerror = false
				this.formloading = false
				this.$emit('update', false)
			},
			validateBeforeSubmit(e) {
				console.log('validate time')


				this.formloading = true
				// collect form data
				/* const qs = require('qs')
				const data = qs.stringify({
					name: this.name,
					namelast: this.namelast,
					email: this.email,
					phone: this.phone,
					comments: this.comments
				}) */

				const data = {
					Name: this.name,
					NameLast: this.namelast,
					Email: this.email,
					Phone: this.phone,
					Message: this.comments
				}

				// TEMP REDIRECT
				// this.$router.push('/thank-you')
				// Send request to api
				// console.log('SENDING EMAIL: ', data)
				// const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
				const posturl =
					process.env.strapiUrl +
					'/form-contacts'
				// const posturl = 'http://localhost:1337/form-contacts'
				console.log('SENDING EMAIL: ', posturl, data)
				this.$axios
					.post(posturl, data)
					.then(res => {
						console.log('Success', res.data)
						if (res.data.id !== null) {
							this.formloading = false
							this.formsuccess = true
							// this.$router.push('/thank-you')
						} else {
							this.formloading = false
							this.formerror = true
						}
						// --reset form
						this.resetForm(e)
					})
					.catch(error => {
						console.log('ERROR', error.response)
						this.formloading = false
						this.formerror = true
						// --reset form
						this.resetForm(e)
					})

			},
			closeForm() {
				this.formsuccess = false
				this.formerror = false
				this.formloading = false
			},
			resetForm(e) {
				// reset form
				this.name = null
				this.namelast = null
				this.email = null
				this.phone = null
				this.comments = null
			},
			updateMessage(e) {
				this.$store.commit('updateMessage', e.target.value)
			}
		},
		beforeCreate() {
			// console.log(`FORM -beforeCreate`)
		},
		created() {
			// console.log(`FORM -created`)
		},
		beforeMount() {
			// console.log(`FORM -beforeMount`)
		},
		mounted() {
			// console.log(`FORM -mounted`)
		},
		beforeUpdate() {
			// console.log(`FORM -beforeUpdate`)
		},
		updated() {
			// console.log(`FORM -updated`)
		},
		beforeDestroy() {
			// console.log(`FORM -beforeDestroy`)
		},
		destoyed() {
			// console.log(`FORM -destoyed`)
		}
	}

